import { __rest } from '../../../../../../_virtual/_tslib.js';
import React from 'react';
import { StyledNavbarBadge } from './NavbarBadge.styles.js';

var NavbarBadge = function NavbarBadge(_a) {
  var children = _a.children,
      _a$isDark = _a.isDark,
      isDark = _a$isDark === void 0 ? false : _a$isDark,
      props = __rest(_a, ["children", "isDark"]);

  return React.createElement(StyledNavbarBadge, Object.assign({
    isDark: isDark
  }, props), React.createElement(React.Fragment, null, children));
};

NavbarBadge.displayName = 'NavbarBadge';
export { NavbarBadge as default };